import { UserService } from '../core/services/user.service';
import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { DashboardService } from '../core/services/dashboard.service';

@Component({
  selector: 'bt-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {
  loading = true;
  userInfo;
  walletAmount;
  monthlyPostReport;
  postCountInformation;
  roleId = +localStorage.getItem('roleId');

  monthlyPostReportChart;
  postCountInformationChart;
  months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  constructor(
    private userService: UserService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit() {
    this.getData();
  }

  private async getData() {
    const temp = [this.userService.getMyInfo(),
    this.dashboardService.getWalletAmount()];
    if (this.roleId === 2) {
      temp.push(this.dashboardService.getMonthlyPostReport(),
        this.dashboardService.getPostCountInformation());
    }
    forkJoin(
      temp
    ).subscribe(
      res => {
        this.userInfo = res[0];
        this.walletAmount = res[1];

        if (this.roleId === 2) {
          this.monthlyPostReport = res[2];
          this.setMonthlyPostReportChart();
          this.postCountInformation = res[3];
        }

        this.loading = false;
      }
    );
  }
  setMonthlyPostReportChart() {
    const data = [];
    let item;
    for (const iterator of this.months) {
      item = this.monthlyPostReport.find(x => x.months === iterator);
      if (item) {
        data.push(item.count);
      } else {
        data.push(0);
      }
    }
    this.monthlyPostReportChart = {
      textStyle: {
        fontFamily: 'IRANSans',
      },
      xAxis: {
        type: 'category',
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        data: this.months
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
      },
      series: [{
        data,
        type: 'line',
        itemStyle: {
          color: '#24d9d9'
        },
      }]
    };
  }
}
